import React, { Component } from 'react'
// import compose from 'recompose/compose'
import { action } from 'mobx'
import { inject, observer } from 'mobx-react'
import { graphql } from 'react-apollo'

import _get from 'lodash/get'
import { Select } from 'antd'

// import withRouting from '~/hocs/withRouting'
// import user from '~/user.json'
import catchmentsQuery from '~/graphql/queries/catchments.gql'
import { ControlSelect, Control } from './styles'
// const { param } = user.data.claims
// const { catchment_id: defaultCatchmentId } = param

@inject('view')
@inject('data')
@inject('user')
@observer
@graphql(catchmentsQuery, {
  props: ({ data: { loading, catchments, refetch } }) => ({
    loading,
    refetch,
    catchments: _get(catchments, 'nodes', [])
  })
})
class CatchmentControl extends Component {
  @action.bound
  handleCatchmentChange (value, label) {
    const { view } = this.props
    view.catchmentId = value
    // setQuery({ catchmentId: value })
    // data.fetchCatchmentStations(value)
  }
  componentWillReceiveProps ({ view: { catchmentId }, user: { profile } }) {
    if (!catchmentId) {
      this.handleCatchmentChange(profile.params.catchment_id) // TODO: read from config
    }
  }

  render () {
    const { view: { catchmentId }, title, catchments = [] } = this.props
    return <Control>
      {title}
      <ControlSelect placeholder="เลือกลุ่มน้ำ" value={`${catchmentId}`} onChange={this.handleCatchmentChange}>
        {catchments.map(catchment =>
          <Select.Option key={catchment.id} value={`${catchment.id}`}>
            {catchment.name}
          </Select.Option>
        )}
      </ControlSelect>
    </Control>
  }
}

export default CatchmentControl



// WEBPACK FOOTER //
// ./src/components/CatchmentControl.js